import { debounce } from 'lodash'

/**
 * Debounces a slice dispatch and action.
 * Helpful with inputs or components that rapidly change state.
 */
export const debouncedDispatch = debounce((dispatch, action) => {
  dispatch(action)
}, 300)
